module.exports = "/assets/delivery/poczta-polska@2x.png?jh1jH91";